// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"877d319a","357":"5442eb74","372":"fbca7c8a","453":"03c97516","695":"23f98c0b","879":"c0664371"}[chunkId] + ".chunk.js";
};